import React, { Component, Fragment } from "react";
import Memberdetail from "./Memberdetail";

class Content extends Component {
  render() {
    return (
      <Fragment>
        <Memberdetail />
        <div className="container">
          <div className="line-bottom"></div>
        </div>
      </Fragment>
    );
  }
}

export default Content;
